import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uiTerminology',
    standalone: true
})
export class UiTerminologyPipe implements PipeTransform {
    transform(value: string | null | undefined, mode: 'text' | 'html' = 'text'): string {
        if (typeof value !== 'string' || !value) {
            return value || '';
        }

        return mode === 'html' ? this.replaceInHtml(value) : this.replaceInText(value);
    }

    private replaceInHtml(html: string): string {
        if (typeof DOMParser === 'undefined') {
            return this.replaceInText(html);
        }

        const parser = new DOMParser();
        const document = parser.parseFromString(html, 'text/html');
        this.walkTextNodes(document.body);
        return document.body.innerHTML;
    }

    private walkTextNodes(node: Node): void {
        node.childNodes.forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
                child.textContent = this.replaceInText(child.textContent || '');
                return;
            }

            if (child.nodeType === Node.ELEMENT_NODE) {
                this.walkTextNodes(child);
            }
        });
    }

    private replaceInText(text: string): string {
        return text
            .replace(/item\(s\)/gi, (match) => this.matchCase(match, 'asset(s)'))
            .replace(/\bitems\b/gi, (match) => this.matchCase(match, 'assets'))
            .replace(/\bitem\b/gi, (match) => this.matchCase(match, 'asset'));
    }

    private matchCase(source: string, target: string): string {
        if (source === source.toUpperCase()) {
            return target.toUpperCase();
        }

        if (source[0] === source[0].toUpperCase()) {
            return target.charAt(0).toUpperCase() + target.slice(1);
        }

        return target;
    }
}
